export const FILTER_LANGUAGE = 'language_id' as const;
export const FILTER_LEVEL = 'level[]' as const;
export const FILTER_CATEGORY = 'q[tagged_with][]' as const;
export const FILTER_FOCUS = 'q[skills_id_in][]' as const;
export const FILTER_SUPPORT_LANGUAGE = 'q[with_support_language][]' as const;
export const FILTER_SEARCH = 'q[title_or_meta_or_objectives_content_cont]' as const;
export const FILTER_DURATION = 'q[average_duration_between_any][]' as const;
export const FILTER_RATING = 'q[_rating][]' as const;
export const FILTER_SORT = 'q[s]' as const;

export type tFILTER_LANGUAGE = typeof FILTER_LANGUAGE;
export type tFILTER_LEVEL = typeof FILTER_LEVEL;
export type tFILTER_CATEGORY = typeof FILTER_CATEGORY;
export type tFILTER_FOCUS = typeof FILTER_FOCUS;
export type tFILTER_SUPPORT_LANGUAGE = typeof FILTER_SUPPORT_LANGUAGE;
export type tFILTER_SEARCH = typeof FILTER_SEARCH;
export type tFILTER_DURATION = typeof FILTER_DURATION;
export type tFILTER_RATING = typeof FILTER_RATING;
export type tFILTER_SORT = typeof FILTER_SORT;
